{{#each this}}
<li class="slider-card" data-action='{{id}}'>
    <div class="btn-id">
        <button data-id='{{id}}' class="btn-youtube-slider">
            <div class="overlay-btn-youtube-text" data-id='{{id}}'>
                <h2 class="btn-youtube-text-slider" data-id='{{id}}'>Trailer</h2>
            </div>
        </button>

    </div>
    <div class="thumb">
        <img class="slider-image" src="https://image.tmdb.org/t/p/w500{{poster_path}}" alt="{{title}} {{name}}"
            data-id="{{id}}"
            onerror="this.onerror=null;this.src='https://ik.imagekit.io/tc8jxffbcvf/default-movie-portrait_EmJUj9Tda5wa.jpg?tr=fo-auto,di-';" />
        <span class="rating-slider">{{vote_average}}</span>
    </div>
</li>
{{/each}}

